const setOrClear = (el, key, value) => {
  if (value === undefined) {
    delete el.dataset[key];
  } else {
    el.dataset[key] = value;
  }
};

const setSselData = (el, value = {}) => {
  const { clickType, label, position, context, pageType, targetUrl } = value;

  setOrClear(el, 'sselClick', clickType);
  setOrClear(el, 'sselLabel', label);
  setOrClear(el, 'sselPosition', position);
  setOrClear(el, 'sselContext', context === undefined ? undefined : JSON.stringify(context));
  setOrClear(el, 'sselPageType', pageType);
  setOrClear(el, 'sselTargetUrl', targetUrl);
};

/**
 * v-ssel-click="{ clickType, label, position, context, pageType, targetUrl }"
 *
 * Convenience layer over the data-ssel-* attribute contract: writes the
 * attributes onto the element, which the global click listener (see
 * sselClickTracker.js) reads on click. Does not attach its own click
 * handler, so tracking never double-fires.
 */
export default {
  bind(el, binding) {
    setSselData(el, binding.value);
  },
  update(el, binding) {
    setSselData(el, binding.value);
  },
};
